export default __webpack_public_path__ + "static/media/reservia.913a43f6.jpg";